import React, { Component } from "react";
import styles from "./filterAndSearchTools.module.scss";
import Icon from "../../../shared/items/static/icon";
import InputMask from "react-input-mask";
import { withLogisticTrips } from "../../../shared/containers/containerLogisticTrips";
import { withLogosticFilter } from "../../../shared/containers/containerLogosticFilter";
import { FormControl, Radio } from "@mui/material";

let searchTimeOutId = null;

class FilterAndSearchTripTools extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTerm: "",
      alarmActive: null,
    };
  }

  componentDidMount() {
    const { onGetLogisticTrips, searchTerm } = this.props;
    const { alarmActive } = this.state;

    onGetLogisticTrips({
      orderBy: "title",
      searchTerm,
      alarmActive,
    });
  }

  onChangeRadio(alarmActive) {
    const { onGetLogisticTrips, searchTerm } = this.props;
    this.setState({ alarmActive });

    onGetLogisticTrips({
      searchTerm,
      alarmActive,
    });
  }

  onChangeSearchTerm(e) {
    const { onGetLogisticTrips, onLogisticSearchTerm } = this.props;
    const { alarmActive } = this.state;

    clearTimeout(searchTimeOutId);
    this.setState({ searchTerm: e.target.value });
    onLogisticSearchTerm(e.target.value);

    searchTimeOutId = setTimeout(() => {
      onGetLogisticTrips({
        searchTerm: e.target.value,
        alarmActive,
      });
    }, 600);
  }

  render() {
    const { searchTerm } = this.state;
    const { titleSearch = "Поиск по рейсам и ТС" } = this.props;
    const { alarmActive } = this.state;

    return (
      <div className={styles.filterContainer}>
        <div className={styles.filterAndSearchToolsContainer}>
          <div className={styles.inputStyle}>
            <InputMask type={"text"} placeholder={titleSearch} onChange={this.onChangeSearchTerm.bind(this)} value={searchTerm} />
          </div>

          <div className={styles.container_searchBtn}>
            <Icon name="search" />
          </div>
        </div>

        <FormControl>
          <div className={styles.radioButtomContainer}>
            <div
              className={styles.radioButtomItem}
              onClick={() => {
                this.onChangeRadio(null);
              }}
            >
              <Radio checked={alarmActive === null} size="small" />
              Все
            </div>

            <div
              className={styles.radioButtomItem}
              onClick={() => {
                this.onChangeRadio(true);
              }}
            >
              <Radio checked={alarmActive === true} size="small" />
              Только с активным расписанием
            </div>

            <div
              className={styles.radioButtomItem}
              onClick={() => {
                this.onChangeRadio(false);
              }}
            >
              <Radio checked={alarmActive === false} size="small" />
              Только без активного расписания
            </div>
          </div>
        </FormControl>
      </div>
    );
  }
}

export default withLogosticFilter(withLogisticTrips(React.memo(FilterAndSearchTripTools)));
